export const withRollbar = fn => window.Rollbar && fn(window.Rollbar);

export const log = (...args) => withRollbar(R => R.log(...args));
export const logError = error => withRollbar(R => R.error(error));
